export let state = {
    accessToken: null,
    expiresIn: 0,
    tokenType: null,
    defaultOrganization: null,
    activeOrganization: null,
    speedUnit: null,
    email: null,
    givenName: null,
    familyName: null,
    permissions: null,
    user_id: null,
    userSession: null,
    setExpirationIsoDate: null
}
